module.exports = __webpack_public_path__ + "img/13.181037a5.png";